export const getBoolOption = (key: string): boolean => {
  return localStorage.getItem(key) === 'true' ? true : false
}

export const getStringOption = (key: string): string => {
  return localStorage.getItem(key)
}
